import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaPostalCodeViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map